import JxFormFieldsBase from '../../JxControls/JxForms/JxFormFieldsBase';
import { createNoteLayout, ImportanceOptions } from './createNoteSchema';

/**
 * CreateNoteDlgBody — field rows for CreateNoteDlgWidget.
 * Extends JxFormFieldsBase for shared Section/FieldRow rendering.
 *
 * @param {object} props.inputs  - field values (createEmpty shape)
 * @param {object} props.errors  - Joi validation errors
 * @param {function} props.onChange - (field, value) => void
 */
export default class CreateNoteDlgBody extends JxFormFieldsBase {
    layout = createNoteLayout();

    constructor(props) {
        super(props);
        this.name = 'CreateNoteDlgBody';
    }

    render() {
        const { Section, FieldRow } = this;
        const { layout } = this;

        return (
            <>
                <FieldRow field="title" {...layout.title} />
                <FieldRow field="service" {...layout.service} />

                <Section title="Metadata" />
                <FieldRow field="cat" {...layout.cat} />
                <FieldRow field="type" {...layout.type} />
                <FieldRow field="stage" {...layout.stage} />
                <FieldRow field="importanceId" {...layout.importanceId} options={ImportanceOptions} />
                <FieldRow field="prioId" {...layout.prioId} options={ImportanceOptions} />
                <FieldRow field="format" {...layout.format} />
                <FieldRow field="viewMode" {...layout.viewMode} />

                {this.props.inputs.tid && <FieldRow field="tid" {...layout.tid} copyable />}
            </>
        );
    }
}
